import { styled } from "styled-components";

export const FeaturesSideMenuContainer = styled.div``;
export const SideMenuLinksContainer = styled.div`
  display: flex;
  padding: 6px 40px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
`;
